import React from 'react';
import { dummyClick } from '../utilities';

const MobileCarret = ({ onClick }) => (
  <div className="left border-right a-header-line-height md-hide lg-hide">
    <span className="ml1 mr1 a-caret-sprite cursor-pointer" onClick={onClick}></span>
  </div>
);

MobileCarret.defaultProps = {
  onClick: dummyClick
};

export default MobileCarret;
